var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3"},[_c('ListHistory'),_c('b-alert',{staticClass:"text-right",attrs:{"show":"","variant":"light"}},[_c('p',{staticClass:"m-0 text-xs"},[_vm._v("Propósito, parametrizar configuraciones por países.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }